<template>
  <v-container fluid class="mt-16 px-6">
    <div>
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Purchase Requests</h2>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="openAddDialog" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Add Purchase Request
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- Purchase Request Table -->
          <internal-purchase-order-table
            ref="internalPurchaseOrderTable"
            @notification="handleNotification"
          />
        </v-card-text>
      </v-card>
    </div>

    <!-- Notification Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import InternalPurchaseOrderTable from "../components/InternalPurchaseOrder/internalPurchaseOrderTable.vue";

export default {
  name: "InternalPurchaseOrder",

  components: {
    InternalPurchaseOrderTable,
  },

  data() {
    return {
      snackbar: {
        show: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
    };
  },

  methods: {
    openAddDialog() {
      this.$refs.internalPurchaseOrderTable.openAddDialog();
    },

    handleNotification(message, type) {
      const colorMap = {
        success: "success",
        error: "error",
        info: "info",
        warning: "warning",
      };

      this.snackbar = {
        show: true,
        message: message,
        color: colorMap[type] || "info",
        timeout: type === "error" ? 5000 : 3000,
      };
    },
  },
};
</script>

<style scoped></style>
